export default __webpack_public_path__ + "static/media/ambasador.546f9bb3.jpg";